export const PIMLICO_API_KEY = import.meta.env.VITE_PIMLICO_API_KEY ?? ''

// console.log('PIMLICO_API_KEY', PIMLICO_API_KEY)